import "../_components/accordion/accordion.js";

const rewardsElements = document.querySelectorAll('.js-element--openRewards');

rewardsElements.forEach(e => {
    e.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.add('mix-bodyIsLocked','mix-globalDialogIsOpen');
        document.getElementById('rewardsModal').classList.add('modal_isActive');
        document.querySelector('.js-globalDialogClose').addEventListener('click', () => {
            document.body.classList.remove('mix-bodyIsLocked','mix-globalDialogIsOpen');
            document.getElementById('rewardsModal').classList.remove('modal_isActive');
        })
    });
});

document.addEventListener("DOMContentLoaded", () => {  
    Collaterate.User.getUser()
        .then(user => {
            if(user.loyalty.availablePoints) {
                document.querySelector('.loyaltyRewardsPointBalance-decalaration-balance').innerHTML = user.loyalty.availablePoints
            }
        })
});